import React from 'react';
import moment from 'moment';
import axios from 'axios';
import FontAwesome from 'react-fontawesome';
import {Button, Modal, OverlayTrigger, Tooltip} from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";

import Table from "../../components/Table/index";

class UserStoryList extends React.Component{
  constructor(props) {
    super(props);
    moment.locale('cs');

    const tooltipPreview = (
      <Tooltip id="tooltip-preview">Zobrazit</Tooltip>
    );
    const tooltipEnable = (
      <Tooltip id="tooltip-enable">Zakázat téma</Tooltip>
    );
    const tooltipDisable = (
      <Tooltip id="tooltip-disable">Povolit téma</Tooltip>
    );
    const tooltipPending = (
      <Tooltip id="tooltip-enable">Odložit téma</Tooltip>
    );
    const tooltipActivate = (
      <Tooltip id="tooltip-disable">Zaktivovat téma</Tooltip>
    );
    const tooltipEdit = (
      <Tooltip id="tooltip-edit">Upravit</Tooltip>
    );
    const tooltipRemove = (
      <Tooltip id="tooltip-remove">Odstranit</Tooltip>
    );

    const columns = [
      {
        Header: 'Název',
        accessor: 'userStoryName'
      },
      {
        id: 'user',
        Header: 'Uživatel',
        accessor: (d) => `${d.userId.nickname} (${d.userId.firstname} ${d.userId.surname})`
      },
      {
        Header: 'Založeno',
        accessor: 'createdAt',
        sortMethod: (a, b) => {
          if (moment(a) < moment(b)) return -1;
          if (moment(a) > moment(b)) return 1;
          return 0;
        },
        Cell: row => moment(row.original.createdAt).format('LLL')
      },
      {
        id: 'enabled',
        Header: 'Viditelný',
        accessor: (d) => d.enabled ? 'ANO' : 'NE',
      },
      {
        id: 'pending',
        Header: 'Odloženo',
        accessor: (d) => d.pending ? 'ANO' : 'NE',
      },
      {
        Header: 'Možnosti',
        style: {padding: '0px'},
        filterable: false,
        sortable: false,
        Cell: row => (
          <div className="row-menu">
            <OverlayTrigger placement="top" overlay={tooltipPreview}>
              <Link to={`/userStories/preview/${row.original._id}`}>
                <FontAwesome
                  name="eye"
                  className="cursor-p"
                />
              </Link>
            </OverlayTrigger>
            {
              row.original.enabled &&
              <OverlayTrigger placement="top" overlay={tooltipEnable}>
                <FontAwesome name="unlock" onClick={() => this.props.handleChangeEnabled(row.original)}
                             className="cursor-p"/>
              </OverlayTrigger>
            }
            {
              !row.original.enabled &&
              <OverlayTrigger placement="top" overlay={tooltipDisable}>
                <FontAwesome
                  name="lock"
                  className="cursor-p"
                  onClick={() => this.props.handleChangeEnabled(row.original)}
                />
              </OverlayTrigger>
            }
            {
              row.original.pending &&
              <OverlayTrigger placement="top" overlay={tooltipActivate}>
                <FontAwesome
                  name="calendar-plus-o"
                  onClick={() => this.props.handleChangePending(row.original)}
                  className="cursor-p"
                />
              </OverlayTrigger>
            }
            {
              !row.original.pending &&
              <OverlayTrigger placement="top" overlay={tooltipPending}>
                <FontAwesome
                  name="calendar-minus-o"
                  className="cursor-p"
                  onClick={() => this.props.handleChangePending(row.original)}
                />
              </OverlayTrigger>
            }
            <OverlayTrigger placement="top" overlay={tooltipEdit}>
              <Link to={`/userStories/edit/${row.original._id}`}>
                <FontAwesome name="pencil-square-o" className="cursor-p" />
              </Link>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={tooltipRemove}>
              <FontAwesome name="trash" onClick={() => this.showModal(row.original)} className="cursor-p"/>
            </OverlayTrigger>
          </div>
        )
      }
    ];

    const tableOptions = {
      showPagination: true,
      showPageSizeOptions: true,
      showPageJump: true,
      collapseOnSortingChange: true,
      collapseOnPageChange: true,
      collapseOnDataChange: true,
      freezeWhenExpanded: false,
      filterable: true,
      sortable: true,
      resizable: true,
      defaultPageSize: 5,
      defaultSorted: [
        {
          id: 'pending',
          desc: true
        },
        {
          id: 'createdAt',
          desc: true
        }
      ]
    };

    this.state = {
      userStories: [],
      removeUserStory: null,
      columns,
      tableOptions
    };

    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    const { accessToken } = this.props.sessionData;
    if (accessToken) {
      this.getUserStories();
    }
  }

  getUserStories() {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      },
      params: {
        limit: 10000
      }
    };
    axios.get(this.props.api.userStories, config)
      .then((result) => {
        if (!this._calledComponentWillUnmount) {
          this.setState({
            userStories: result.data,
            tableOptions: {
              ...this.state.tableOptions,
              loading: false
            }
          });
        }
      }).catch(function (error) {
      console.error('Error axios:', error);
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
      removeUserStory: null
    })
  }

  showModal(userStory) {
    this.setState({
      showModal: true,
      removeUserStory: userStory
    })
  }

  render() {
    let {userStories, removeUserStory} = this.state;
    return (
      <div className="x-panel">
        <div className="x-title">
          <h2>Seznam témat soutěžících</h2>
          <div className="clearfix"/>
        </div>
        <div className="x-content">
          <Table
            columns={this.state.columns}
            data={userStories}
            tableOptions={this.state.tableOptions}
            defaultFilterMethod={(filter, row) => (String(row[filter.id]).includes(filter.value))}
          />
        </div>
        {
          removeUserStory &&
          <Modal show={this.state.showModal} onHide={this.closeModal} backdrop='static'>
            <Modal.Header closeButton className="text-danger bg-danger">
              <Modal.Title>Odstranění tématu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Opravdu chcete odstranit téma: {removeUserStory.name}?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.closeModal}>Zrušit</Button>
              <Button className='btn btn-danger' onClick={() => this.props.handleRemoveUserStory(removeUserStory)}>Odstranit</Button>
            </Modal.Footer>
          </Modal>
        }
      </div>
    );
  }
}

export default withRouter(UserStoryList);



/** WEBPACK FOOTER **
 ** ./src/containers/UserStories/UserStoriesList.js
 **/